import PropTypes from "prop-types";

import ChartBase from "@/components/Elements/Charts/ChartBase";

import { useDonutChartOptions } from "./useDonutChartOptions";

const DonutChart = ({
  data = [],
  controlled,
  onLegendSelectChange,
  formatTotal = (total) => total,
  formatName = (name) => name,
  formatLabel = ({ value }) => value,
  formatTooltipValue = (value) => value,
  chartLeftPosition,
  hideLegend = false,
  hideTotal = false,
  hideLabels = false,
  customOptions = {},
  ...chartBaseProps
}) => {
  const options = useDonutChartOptions({
    data,
    formatTotal,
    formatName,
    formatLabel,
    formatTooltipValue,
    controlled,
    chartLeftPosition,
    hideLegend,
    hideTotal,
    hideLabels,
    customOptions,
  });

  return (
    <ChartBase
      {...chartBaseProps}
      options={options}
      onLegendSelectChange={onLegendSelectChange}
      reverseLegendSelection
    />
  );
};

DonutChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
  formatTotal: PropTypes.func,
  formatName: PropTypes.func,
  formatLabel: PropTypes.func,
  formatTooltipValue: PropTypes.func,
  onLegendSelectChange: PropTypes.func,
  controlled: PropTypes.shape({
    selectedLegend: PropTypes.shape({ [PropTypes.string]: PropTypes.bool })
      .isRequired,
  }),
  chartLeftPosition: PropTypes.string, // Usefull to give enough space for the legend
  hideLegend: PropTypes.bool,
  hideTotal: PropTypes.bool,
  hideLabels: PropTypes.bool,
  customOptions: PropTypes.shape({
    title: PropTypes.object,
    legend: PropTypes.object,
    series: PropTypes.object,
    tooltip: PropTypes.object,
  }),
};

export default DonutChart;
